import { computed, inject, Injectable, Injector, signal } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs";
import { AccessControlService } from "./accesscontrol.service";

export interface Breadcrumb {
  label: string;
  url: string;
}

@Injectable({
  providedIn: "root",
})
export class BreadcrumbService {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private injector = inject(Injector);
  private accessControlService = inject(AccessControlService);

  hasBMSGPKPermission = this.accessControlService.hasPermission("bMSGPKDisplay");

  private breadcrumbsSignal = signal<Breadcrumb[]>([]);

  breadcrumbs = computed(() => this.breadcrumbsSignal());

  constructor() {
    this.breadcrumbsSignal.set(this.buildBreadcrumbs(this.route.root));

    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      const breadcrumbs = this.buildBreadcrumbs(this.route.root);
      this.breadcrumbsSignal.set(breadcrumbs);
    });
  }

  private buildBreadcrumbs(route: ActivatedRoute, url: string = "", breadcrumbs: Breadcrumb[] = []): Breadcrumb[] {
    const children = route.children;
    if (children.length === 0) {
      return breadcrumbs;
    }

    for (const child of children) {
      const routeSnapshot = child.snapshot;
      const routeURL = routeSnapshot.url.map((segment) => segment.path).join("/");
      const nextUrl = routeURL ? `${url}/${routeURL}` : url;

      const breadcrumbData = routeSnapshot.data?.["breadcrumb"];

      if (breadcrumbData?.alias === "SMS") {
        const isWsRoute = this.route.snapshot.url.some((s) => s.path === "wirtschaftlicherstatus");
        if (isWsRoute || this.hasBMSGPKPermission.data()) {
          breadcrumbData.alias = "Sachbereiche";
        }
      }

      if (breadcrumbData) {
        const label = breadcrumbData.alias || breadcrumbData.callableAlias(this.injector) || breadcrumbData;
        if (breadcrumbs.length === 0 || breadcrumbs[breadcrumbs.length - 1].label !== label) {
          breadcrumbs.push({ label, url: nextUrl });
        }
      }

      this.buildBreadcrumbs(child, nextUrl, breadcrumbs);
    }

    return breadcrumbs;
  }
}
